import graphqlClient from "../../../apollo";

class CompanyPdfLogoProvider {
  get() {
    return graphqlClient.query({
      query: require("./gql/companyPdfLogoGet.graphql"),
      fetchPolicy: "network-only",
    });
  }

  update(variables) {
    return graphqlClient.mutate({
      mutation: require("./gql/companyPdfLogoUpdate.graphql"),
      variables,
    });
  }
}

export default new CompanyPdfLogoProvider();
